import React from 'react';
import styled from '@benzinga/themetron';
interface ThemeColorsProps {
  colors: string[];
}

export const ThemeColors: React.FC<ThemeColorsProps> = props => {
  return (
    <Wrapper>
      {(props.colors as string[]).map((c, index) => (
        <Circle color={c} key={`${index}-${c}`} />
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2px;
  justify-content: center;
  align-items: center;
`;
const Circle = styled.div<{ color: string }>`
  height: 12px;
  width: 12px;
  border-radius: 50%;
  background-color: ${props => props.color};
`;
